/* ---------------------------------------------------------------------------
   Bottega d'Arte Stringa — cosa succede quando un pezzo va a zero.
   Chiesto da Raffaella il 15/09/2026.

   La regola, una sola: **"Aggiungi al carrello" resta su tutti i prodotti,
   sempre.** L'unica eccezione e' la giacenza a zero su un pezzo che non si puo'
   ordinare: li' il bottone non si puo' premere, e al suo posto compare
   "Richiedi", che porta al modulo gia' compilato col nome del pezzo.

   Non e' una pezza sui prodotti esauriti di oggi: la condizione si legge dal
   pezzo, quindi vale per qualunque prodotto vada a zero domani, e sparisce da
   sola quando torna disponibile.

   Come riconosce un esaurito, in ordine:
     1. data-giacenza="0"        <- il dato vero; sul tema Shopify diventa
                                    data-giacenza="{{ variant.inventory_quantity }}"
     2. data-ordinabile="no" +   <- quando la giacenza non e' esposta
        classe .esaurito
     3. un bottone che dice gia' "Esaurito"
   Un pezzo a zero ma ordinabile (data-ordinabile="si") non viene toccato: quello
   si compra normalmente e lo dice la scheda, non questo file.
   --------------------------------------------------------------------------- */
(function () {
  "use strict";

  var PAGINA = "/pages/richiesta-prodotto";  // su Shopify e una pagina, non un file accanto

  var css = document.createElement("style");
  css.textContent = [
    ".av-esaurito{display:block}",
    ".av-esaurito .av-stato{display:flex;align-items:center;justify-content:center;gap:7px;",
    "margin-bottom:9px;font-family:'DM Sans',Arial,sans-serif;font-size:11px;font-weight:700;",
    "letter-spacing:.09em;text-transform:uppercase;color:var(--urgency,#A6552E)}",
    ".av-esaurito .av-stato .pallino{width:7px;height:7px;border-radius:50%;background:currentColor;flex:none}",
    ".av-chiedi{display:block;width:100%;box-sizing:border-box;text-align:center;text-decoration:none;",
    "padding:13px 14px;border-radius:999px;border:1px solid var(--forest,#25451C);",
    "background:var(--forest,#25451C);color:#fff;font-family:'DM Sans',Arial,sans-serif;",
    "font-size:12px;font-weight:600;letter-spacing:.03em;text-transform:uppercase;line-height:1.3;cursor:pointer}",
    ".av-chiedi:hover{background:var(--forest-deep,#182E12)}",
    ".av-chiedi-nota{margin-top:8px;font-family:'DM Sans',Arial,sans-serif;font-size:11.5px;",
    "line-height:1.5;color:var(--ink-soft,#54666B);text-align:center}",
    ".av-spento{opacity:.4;pointer-events:none;filter:grayscale(1)}"
  ].join("");
  document.head.appendChild(css);

  function nomeDi(contenitore) {
    var t = contenitore.querySelector(".card-title, .cn, h1, h3");
    if (!t) {
      var scheda = document.querySelector(".buybox h1, h1");
      t = scheda || null;
    }
    if (!t) return "";
    var copia = t.cloneNode(true);
    [].slice.call(copia.querySelectorAll(".example-tag")).forEach(function (n) {
      n.parentNode.removeChild(n);
    });
    return (copia.textContent || "").replace(/\s+/g, " ").trim();
  }

  function esaurito(el) {
    var g = el.getAttribute("data-giacenza");
    var ordinabile = (el.getAttribute("data-ordinabile") || "").toLowerCase();
    if (ordinabile === "si" || ordinabile === "sì") return false;   // si ordina: non si tocca
    if (g !== null && g !== "") return parseInt(g, 10) <= 0;
    if (/(^|\s)esaurito(\s|$)/.test(el.className)) return true;
    var b = el.querySelector(".card-actions a, .card-actions button, .btn.block");
    return !!(b && /esaurito|sold out|non disponibile/i.test(b.textContent || ""));
  }

  // sostituisce il bottone dentro `zona` con lo stato + la richiesta
  function metti(zona, nome) {
    var vecchio = zona.querySelector("a.btn, button.btn, .btn");
    var blocco = document.createElement("div");
    blocco.className = "av-esaurito";

    var stato = document.createElement("div");
    stato.className = "av-stato";
    var pallino = document.createElement("span");
    pallino.className = "pallino";
    stato.appendChild(pallino);
    stato.appendChild(document.createTextNode("Esaurito"));

    var link = document.createElement("a");
    link.className = "av-chiedi";
    link.href = PAGINA + (nome ? "?prodotto=" + encodeURIComponent(nome) : "");
    link.textContent = "Richiedi se si può ordinare";

    var nota = document.createElement("div");
    nota.className = "av-chiedi-nota";
    nota.textContent = "Ti rispondiamo noi dal negozio, senza impegno";

    blocco.appendChild(stato);
    blocco.appendChild(link);
    blocco.appendChild(nota);

    if (vecchio) vecchio.parentNode.replaceChild(blocco, vecchio);
    else zona.appendChild(blocco);
  }

  // --- le schede nelle griglie ---------------------------------------------
  [].slice.call(document.querySelectorAll(".card")).forEach(function (card) {
    if (!esaurito(card)) return;
    var zona = card.querySelector(".card-actions") || card;
    metti(zona, nomeDi(card));
    card.style.opacity = "1";
    var img = card.querySelector(".imgwrap img");
    if (img) img.style.opacity = ".78";
  });

  // --- la scheda prodotto ---------------------------------------------------
  var buybox = document.querySelector(".buybox");
  if (buybox && esaurito(buybox)) {
    var bottone = buybox.querySelector(".btn.block");
    if (bottone) {
      var zona = document.createElement("div");
      bottone.parentNode.insertBefore(zona, bottone);
      zona.appendChild(bottone);
      metti(zona, nomeDi(buybox));
    }
    // il selettore di quantita' non ha senso su un pezzo che non si compra
    var qta = buybox.querySelector(".qta");
    if (qta) qta.classList.add("av-spento");
  }
})();
